export default __webpack_public_path__ + "static/media/ovary.50059713.jpg";